const BASE_URL = "https://adtwd.in/api"; // Live
// const BASE_URL = "http://localhost:3033"; // Local

export default BASE_URL;